import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { connect, useDispatch, useSelector } from "react-redux";
import EditPopUpAdmin from "./parteAnexo/EditPopUpAdmin";
import {
  Button,
  Checkbox,
  CircularProgress,
  Fade,
  FormLabel,
} from "@mui/material";
import Swal from "sweetalert2";
import axios from "axios";
import { ACTUALIZAR_LISTA } from "../../../redux/constanst";
import { hosting } from "../models/buscar";
import { CheckBox } from "@mui/icons-material";
import { useState } from "react";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function AnexosEdit({ data }) {
  const [disabledStatus, setDisabledStatus] = useState([]);

  const [disabledStatusAll, setDisabledStatusAll] = useState(false);
  const { actualizarLista } = useSelector((state) => state.userState);
  const dispatch = useDispatch();

  const disableButtom = (data) => {
    const arrNew = disabledStatus;
    arrNew[data.extension] = true;
    setDisabledStatus(arrNew);
    setDisabledStatusAll(true);
    enviar(data);
  };
  const enviar = async (data) => {
    data.status = data.status === "1" ? 0 : 1;
    axios
      .get(
        `${hosting}/mimegacall/api/addEdit_anexos.php?extension=${data.extension}&name=${data.name}&channel=${data.channel}&status=${data.status}`
      )
      .then((response) => {
        if (response.data.type === "SQL") {
          Swal.fire(
            "Error al editar Anexo, pongase en contacto con el administrador",
            ``,
            "error"
          ).then(() => {
            return;
          });
        } else {
          dispatch({
            type: ACTUALIZAR_LISTA,
            actualizarLista: !actualizarLista,
          });
          Swal.fire(response.data.mensaje, ``, response.data.type).then(
            (result) => {
              setDisabledStatus([]);
              setDisabledStatusAll(false);
            }
          );
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const alerta = (datos) => {
    Swal.fire({
      title: `¿Seguro que quiere eliminar a ${datos.name}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(
            `${hosting}/mimegacall/api/addEdit_anexos.php?type=delete&extension=${datos.extension}&channel=${datos.channel}`
          )
          .then((response) => {
            Swal.fire(response.data.mensaje, ``, `${response.data.type}`).then(
              (result) => {
                dispatch({
                  type: ACTUALIZAR_LISTA,
                  actualizarLista: !actualizarLista,
                });
              }
            );
          })
          .catch(function (error) {});
      }
    });
  };
  return (
    <TableContainer component={Paper}>
      <Table sx={{ maxWidth: "100%" }} aria-label="customized table">
        <TableHead style={{ background: "red" }}>
          <TableRow>
            <StyledTableCell style={{ backgroundColor: "#F4796D" }}>
              Channel
            </StyledTableCell>
            <StyledTableCell
              style={{ backgroundColor: "#F4796D" }}
              align="center"
            >
              Extension
            </StyledTableCell>

            <StyledTableCell
              style={{ backgroundColor: "#F4796D" }}
              align="center"
            >
              Name
            </StyledTableCell>

            <StyledTableCell
              style={{ backgroundColor: "#F4796D" }}
              align="center"
            >
              Empresa
            </StyledTableCell>
            <StyledTableCell
              style={{ backgroundColor: "#F4796D" }}
              align="center"
            >
              Sucursal
            </StyledTableCell>
            <StyledTableCell
              style={{ backgroundColor: "#F4796D" }}
              align="center"
            >
              Status
            </StyledTableCell>
            <StyledTableCell
              style={{ backgroundColor: "#F4796D" }}
              align="center"
            ></StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((anexo, index) => {
            if (anexo.channel !== "-1") {
              return (
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    {anexo.channel}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {anexo.extension}
                  </StyledTableCell>

                  <StyledTableCell align="center">{anexo.name}</StyledTableCell>
                  <StyledTableCell align="center">
                    {anexo.empresa}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {anexo.sucursal}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <div>
                      <Fade
                        in={disabledStatus[anexo.extension]}
                        style={{
                          transitionDelay: disabledStatus[anexo.extension]
                            ? "800ms"
                            : "0ms",
                        }}
                        unmountOnExit
                      >
                        <CircularProgress color="error" size={25} />
                      </Fade>
                    </div>
                    <div>
                      <Checkbox
                        defaultChecked={anexo.status === "1" ? true : false}
                        style={{
                          display: disabledStatus[anexo.extension]
                            ? "none"
                            : "block",
                        }}
                        disabled={disabledStatusAll}
                        onChange={() => disableButtom(anexo)}
                      />
                    </div>

                    {anexo.status === "1" ? "Activado" : "Desactivado"}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    <EditPopUpAdmin
                      style={{
                        height: 30,
                        marginLeft: 1,
                        marginRight: 1,
                        marginBottom: 1,
                        backgroundColor: "orange",
                      }}
                      btnLabel={"Editar anexos"}
                      datos={anexo}
                    />
                    <Button
                      style={{
                        width: "auto",
                        height: "auto",
                        backgroundColor: "red",
                        marginLeft: 20,
                        marginRight: 20,
                        marginBottom: 20,
                      }}
                      onClick={() => alerta(anexo)}
                      variant="contained"
                    >
                      <p style={{ fontSize: 10 }}>ELIMINAR ANEXO</p>
                    </Button>
                  </StyledTableCell>
                </StyledTableRow>
              );
            }
            return null;
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
const mapStateToProps = (store) => ({});

export default connect(mapStateToProps, null)(AnexosEdit);
